<template>
  <b-row class="input-add-use mb-3">
    <b-col :sm="labelSm" class="label-col">
      <label :for="'input-' + fieldKey">{{ label }}:</label>
    </b-col>
    <b-col :sm="valueSm">
      <b-form-checkbox
          v-if="type === 'checkbox'"
          v-model="DATA[fieldKey]"
          size="sm"
          class="left"
      ></b-form-checkbox>
      <div v-if="type !== 'date' && type !== 'checkbox'"
            class="left"
           :class="{'translation': isTranslation(fieldKey, DATA.translations)}"
           v-show="!editSwitch"
           v-on:dblclick="enableEdit"
      >
        <span :class="{
          'editable': type != 'static',
          'static': type == 'static',
        }"
        >{{ sFormat(DATA[fieldKey]) }}</span>
      </div>

      <b-form-input
          ref="text"
          v-if="type === 'text'"
          type="text"
          :id="'input-'+ fieldKey"
          v-model="DATA[fieldKey]"
          size="sm"
          v-show="editSwitch"
          v-on:focusout="editSwitch = false"
          v-on:change="editSwitch = false"
      ></b-form-input>
      <b-form-input
          ref="number"
          v-if="type === 'number'"
          type="number"
          :id="'input-'+ fieldKey"
          v-model="DATA[fieldKey]"
          size="sm"
          v-show="editSwitch"
          v-on:focusout="editSwitch = false"
          v-on:change="editSwitch = false"
      ></b-form-input>
      <b-form-textarea
          ref="textarea"
          v-if="type === 'textarea'"
          :id="'input-'+ fieldKey"
          v-model="DATA[fieldKey]"
          size="sm"
          v-show="editSwitch"
          v-on:focusout="editSwitch = false"
          v-on:change="editSwitch = false"
      ></b-form-textarea>
      <b-form-datepicker
          ref="date"
          v-if="type === 'date'"
          @context="editSwitch = false"
          v-on:focusout="editSwitch = false"
          v-model="DATA[fieldKey]"
          :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          locale="ru"
          type="text"
          class="form-control input-group-sm datepicker"
          dropright="dropright"
          size="sm"
      ></b-form-datepicker>

    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "EditableField",
  props: {
    DATA: Object,
    fieldKey: String,
    label: String,
    type: String,
    labelSm: {
      type: Number,
      default: 2,
    },
    valueSm: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      editSwitch: false,
    }
  },

  methods: {
    async enableEdit() {
      if (this.type == 'static') {
        return false
      }
      this.editSwitch = true
      await this.$refs[this.type].$el.focus()
      await this.$refs[this.type].focus()
    }
  },
  created() {
    // console.log(this.fieldKey)
  }
}
</script>

<style scoped>
.left {
  text-align: left;
}
.label-col {
  text-align: right;
}
.translation {
  background-color: #FFA500;
}
.editable {
  cursor: pointer;
}
.static {
  background-color: #ddd;
}
</style>